/** Seconds after opposing Exclusion/Suspension on the same-quarter clock for auto–Power Play. */
export const POWERPLAY_SHORT_WINDOW_SECONDS = 18;

/** Seconds of match clock elapsed after opposing Brutality (may span quarters). */
export const POWERPLAY_BRUTALITY_WINDOW_SECONDS = 240;
